import Vue from 'vue'
import Vuex from 'vuex'
import service from '../../services/gestionTiempos/accessControl'


Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        service: new service(),
        date: null,
        accessControl:[],
        new:{},
    },
    mutations: {
       
        setAccessControl(state,data){
            state.accessControl = data 
        },
        setDate(state,data){
          state.date =data
        },
        
       
    },
    actions: {
     
        async getAccessControl(state) {
            try {
              let item = await state.state.service.getAccessControl(state.state.accessControl);
      
              state.commit("setAccessControl", { item });
            } catch (error) {
              console.log(error);
            }
          },
         
        
    },
   


})